<!-- 헤더 컴포넌트 -->
<template>
    <div class="detail-header">
        <div v-if="currentNode" class="d-flex justify-content-between col-md-12 detail-title">
            <div class="col-sm-7 d-flex align-items-center">
                <span class="badge title1"> {{ currentNode.text }} </span>
                <span class="badge title2"> {{ currentNode.sysNodeIdx }} </span>
                <span class="badge others"> {{ systemName }} </span>
                <span v-show="currentNode.nodeType !== 'System'" class="badge others">
                    {{ equipName }}
                </span>
                <span class="badge others">
                    {{ nodeTypeValue && nodeTypeValue }}
                </span>
                <span
                    v-if="filterSystemType.sumAvail == 'Y' && currentNode.nodeType !== 'Equip'"
                    class="badge others"
                    style="cursor: pointer"
                    @click="handleSavePointClick"
                >
                    {{ !isEmpty(nodeInfo?.savePtAddr) ? nodeInfo.savePtAddr : "저장 관제점 연결" }}
                </span>
                <span class="badge others">{{
                    sumNodeTotal &&
                    sumNodeTotal.trendData &&
                    phscPointUsageMap?.get(sumNodeTotal.trendData.headers?.engUseType)
                        ? phscPointUsageMap.get(sumNodeTotal.trendData.headers.engUseType)
                        : "-"
                }}</span>
            </div>
            <div class="col-sm-5 p-0 d-flex justify-content-end">
                <slot name="controls"></slot>
            </div>
        </div>
        <h5 v-else>설비 현황</h5>
    </div>
</template>

<script>
export default {
    name: "DetailHeader",
    props: {
        currentNode: {
            type: Object,
            default: null,
        },
        systemName: {
            type: String,
            default: null,
        },
        equipName: {
            type: String,
            default: null,
        },
        nodeTypeValue: {
            type: String,
            default: null,
        },
        nodeInfo: {
            type: Object,
            default: null,
        },
        sumNodeTotal: {
            type: Object,
            default: null,
        },
        phscPointUsageMap: {
            type: Map,
            default: () => new Map(),
        },
        filterSystemType: {
            type: Object,
            default: null,
        },
    },
    emits: ["save-point-click"],
    methods: {
        handleSavePointClick() {
            this.$emit("save-point-click");
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../styles/common/_detail-common.scss";

.detail-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.detail-title {
    padding: 0 !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1rem;
    font-weight: 600;
}
</style>
